// CANONICAL COPY (GH #7115). src/constants/obligations/obl-operational-planning.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-operational-planning',
  title: 'Review operational planning and control',
  description:
    'Confirm that the processes needed to meet ISMS requirements and to implement risk-treatment actions are planned, implemented and controlled. Review covers management of planned and unintended changes, outsourced processes and operational criteria.',
  category: 'governance',
  scfIds: ['SCF-MSS-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Operational planning and control procedure is published',
    },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
